import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Camera } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Stars } from "@/components/Stars";

const ItemReview = ({ code, item, email, done, onDone }) => {
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [photo, setPhoto] = useState(null);
  const [busy, setBusy] = useState(false);
  const id = item.product_id;

  if (done) return <p className="text-sm text-[#00A651]" data-testid={`review-done-${id}`}>Grazie! Recensione pubblicata.</p>;

  const submit = async () => {
    if (!email) return toast.error("Inserisci l'email usata per l'ordine");
    if (photo && photo.size > 5 * 1024 * 1024) return toast.error("Foto troppo grande (max 5 MB)");
    setBusy(true);
    try {
      let photo_path = null;
      if (photo) {
        const fd = new FormData();
        fd.append("email", email);
        fd.append("file", photo);
        photo_path = (await api.post(`/orders/track/${code}/review-photo`, fd)).data.photo_path;
      }
      await api.post(`/orders/track/${code}/reviews`, { email, product_id: id, rating, comment, photo_path });
      toast.success("Recensione pubblicata");
      onDone(id);
    } catch (er) { toast.error(errMsg(er)); } finally { setBusy(false); }
  };

  return (
    <div className="space-y-2">
      <Stars value={rating} size={22} onChange={setRating} testid={`review-stars-${id}`} />
      <textarea data-testid={`review-comment-${id}`} rows={2} value={comment} onChange={(e) => setComment(e.target.value)}
        placeholder="Com'è andata? Racconta la tua esperienza" className="field text-sm" />
      <label className="flex items-center gap-3 text-sm cursor-pointer w-fit">
        <span className="btn-ghost tag px-3 py-2 flex items-center gap-2"><Camera size={14} /> {photo ? "Cambia foto" : "Aggiungi foto"}</span>
        <input data-testid={`review-photo-input-${id}`} type="file" accept="image/jpeg,image/png,image/webp" className="hidden"
          onChange={(e) => setPhoto(e.target.files?.[0] || null)} />
        {photo && <img src={URL.createObjectURL(photo)} alt="" className="w-12 h-12 object-cover border border-[#0F0F0F]" data-testid={`review-photo-preview-${id}`} />}
      </label>
      <button data-testid={`review-submit-${id}`} onClick={submit} disabled={busy || comment.trim().length < 3} className="btn-primary px-4 h-9 text-sm">
        Pubblica recensione
      </button>
    </div>
  );
};

export const OrderReviews = ({ order }) => {
  const [done, setDone] = useState([]);
  const [email, setEmail] = useState("");
  useEffect(() => { api.get(`/orders/track/${order.code}/reviews`).then((r) => setDone(r.data)); }, [order.code]);

  return (
    <section className="border border-[#0F0F0F] bg-white p-5 space-y-5" data-testid="order-reviews">
      <div>
        <span className="tag text-[#555]">Ordine consegnato</span>
        <h2 className="font-display font-extrabold text-2xl tracking-tight">Lascia una recensione</h2>
      </div>
      <input data-testid="review-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
        placeholder="Email usata per l'ordine (per verifica)" className="field" />
      {order.items.map((i) => (
        <div key={i.product_id} className="flex gap-4 border-t border-[#0F0F0F]/15 pt-4">
          <img src={i.image} alt="" className="w-14 h-14 object-cover border border-[#0F0F0F]" />
          <div className="flex-1 space-y-2">
            <p className="text-sm font-medium">{i.title}</p>
            <ItemReview code={order.code} item={i} email={email} done={done.includes(i.product_id)} onDone={(pid) => setDone([...done, pid])} />
          </div>
        </div>
      ))}
    </section>
  );
};
